import { render, staticRenderFns } from "./CustomerRemarks.vue?vue&type=template&id=ba91926a&scoped=true"
import script from "./CustomerRemarks.vue?vue&type=script&lang=js"
export * from "./CustomerRemarks.vue?vue&type=script&lang=js"
import style0 from "./CustomerRemarks.vue?vue&type=style&index=0&id=ba91926a&prod&lang=postcss&scoped=true"
import style1 from "./CustomerRemarks.vue?vue&type=style&index=1&id=ba91926a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba91926a",
  null
  
)

export default component.exports